import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { actions as personalActions } from '../../../../settings/actions/personal';
import { CustomCardsItem } from '../../../components/sidebar/cards/customCardsItem';

const mapStateToProps = (state) => {
  return {
    conversationCardsSettings: state.settings.personal.conversationCards,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConversationCards: bindActionToPromise(
      dispatch,
      personalActions.personalConversationCards,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomCardsItem);
